import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import MuvikaService from './../services/muvika';
import messageStore from './message';
import ExternalViewCommands from './../services/external';
import TR from './../Trans';
import IntervalService from './../services/intervals';
import { Capacitor } from '@capacitor/core';
import navigationStore from './navigation';
import performanceStore from './performance';
import accountStore from './account';
import settingsStore from './settings';
import singersStore from './singers';
import newTracksStore from './newTracks';
import favoritesStore from './favorites';
import catalogStore from './catalog';
import environmentStore from './environment';
import musicStore from './music';
import musicPlayerStore from './musicPlayer';
import newsStore from './news';
import playerStore from './player';
import searchStore from './search';
import homeStore from './home';
import songListStore from './songList';
import timeoutsStore from './timeouts';
import statusStore from './status';
import bgFiltersStore from './bgFilters';
import bgPlaylistsStore from './bgPlaylists';
import bgPerformanceStore from './bgPerformance';
import bgStylesStore from './bgStyles';
import bgSearchStore from './bgSearch';
import { generateId } from '../services/random';
import muvikaAttrs from './../attrs';
import songbookQueueStore from './songbookQueue';

const sessionExpiredCode = 2004;

const initialState = {
  isSessionOpening: false,
  isSessionOpen: false,
  isLoggedAs: null,
  isThrownOut: false,
  sessionToken: "",
  isLoggedIn: false,
  isAckSmartQ: false,
  isWaitingBack: false,
  externalWindowHandler: null,
  session: null,
  /* isSongbookLoggedIn: false,
  isSongbookWelcomeRead: false,
  isSongbookPublicMode: false,
  isSongbookPublicBoothMode: false, */
  isLoginSeqErrors: false,
  isLoginSeqError: false,
  isWaiting: false,
  requestCount: 0,
  isMoveToExternalScreen: false,
  isApiWindowPerm: false,
  isWaitingLoggedIn: false,
};

const sessionStore = create(
  persist(
    (set, get) => ({
      ...initialState,
      reset: () => {
        set(initialState);
      },
      setApiWindowPerm: (isApiWindowPerm) => {
        set({ isApiWindowPerm: isApiWindowPerm });
      },
      setAlwaysMoveToExternalScreen: (isMoveToExternalScreen) => {
        set({ isMoveToExternalScreen: isMoveToExternalScreen });
      },
      setExternalWindowHandler: (handler) => {
        set({ externalWindowHandler: handler });
      },
      zeroRequestCount: () => {
        set({ requestCount: 0 });
      },
      incRequestCount: () => {
        console.log("incRequestCount", get().requestCount)
        set({ requestCount: get().requestCount + 1 });
      },
      setThrownOut: (isThrownOut) => {
        set({ isThrownOut: isThrownOut });
      },
      ackSmartQ: () => {
        set({ isAckSmartQ: true });
      },
      setIsSongbookWelcomeRead: (isRead) => {
        set({ isSongbookWelcomeRead: isRead });
      },
      openSession: (language) => {
        set({ isSessionOpening: true });
        console.log("opening session");
        MuvikaService.openSession(language)
          .then(function (res) {
            //console.log(JSON.stringify(res));
            if (res.data.error) {
              set({ isSessionOpen: false, isLoggedIn: false, isThrownOut: false, isSessionOpening: false });
              if (res.data.error.details.length > 0) {
                messageStore.getState().setError("", res.data.error.code, res.data.error.details);
              } else {
                messageStore.getState().setError("", 1000010, TR.cm_session_start_failed);
              }
            } else {
              TR.setLanguage(language);
              document.title = TR.ww_page_title;
              localStorage.setItem(muvikaAttrs.service + "-session-language", JSON.stringify(language));
              set({ isSessionOpen: true, isLoggedIn: false, sessionToken: res.data.session_token, isThrownOut: false, isSessionOpening: false });
            }
          })
          .catch(function () { });
      },
      updateSession: (sessionToken, language) => {
        MuvikaService.updateSession(sessionToken, language)
          .then(function (res) {
            if (res.data.error) {
              if (res.data.error.code === sessionExpiredCode && sessionToken.length > 0) {
                console.log("opening session");
                get().openSession(language);
              } else {
                messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
              }
            } else {
              TR.setLanguage(language);
              document.title = TR.ww_page_title;
              localStorage.setItem(muvikaAttrs.service + "-session-language", JSON.stringify(language));
              environmentStore.getState().getEnvironment(sessionToken, language);
            }
          })
          .catch(function () { });
      },
      clearSession: () => {
        set({ isSessionOpen: false, isLoggedIn: false, sessionToken: "", session: null, isThrownOut: false });
      },
      loginSeq: (sessionToken, isFirst) => {
        /* let accountPromise = MuvikaService.getAccount(sessionToken)
          .then(function (res) {
            if (res.data.error) {
              set({ isLoginSeqErrors: true });
            } else {
              let account = res.data.data.account;
              let urls = res.data.data.urls;
              let language = account.language.toLowerCase();
              TR.setLanguage(language);
              localStorage.setItem(muvikaAttrs.service+"-session-language", JSON.stringify(language));
              document.title = TR.ww_page_title;
              environmentStore.getState().getEnvironment(sessionToken);
              accountStore.setState({ isSet: true, account: { ...account }, urls: urls });
              set({ loginSeqsCompleted: get().loginSeqsCompleted + 1 });
            }
          })
          .catch(function () { set({ isLoginSeqErrors: true }); }); */

        let newsPromise = MuvikaService.getNews(sessionToken, 25, 1)
          .then(function (res) {
            if (res.data.error) {
              set({ isLoginSeqErrors: true });
            } else {
              newsStore.setState({ isSet: true, news: res.data.data.items });
              set({ loginSeqsCompleted: get().loginSeqsCompleted + 1 });
            }
          })
          .catch(function () { set({ isLoginSeqErrors: true }); });

        let settingsPromise = MuvikaService.getSettings(sessionToken)
          .then(function (res) {
            if (res.data.error) {
              set({ isLoginSeqErrors: true });
            } else {
              let settings = res.data.data;
              settingsStore.setState({ isSet: true, settings: settings });
              playerStore.setState({ currentVersion: settings.voc_enabled ? "vocal" : "normal" });
              set({ loginSeqsCompleted: get().loginSeqsCompleted + 1 });
            }
          })
          .catch(function () { set({ isLoginSeqErrors: true }); });

        let playQueuePromise = MuvikaService.getPlayQueue(sessionToken)
          .then(function (res) {
            if (res.data.error) {
              set({ isLoginSeqErrors: true });
            } else {
              let playQueue = { ...res.data.data };
              if (playQueue) {
                if (playQueue.items) {
                  let duration = 0;
                  for (let i = 0; i < playQueue.items.length; i++) {
                    playQueue.items[i].position = i;
                    playQueue.items[i].incoming = duration;
                    duration += playQueue.items[i].track.length.split(':').reduce((acc, time) => (60 * acc) + +time);
                  }
                  if (playQueue.items.length > 0) {
                    performanceStore.setState({ currentPerformance: playQueue.items[0] });
                  }
                  performanceStore.setState({ playQueue: playQueue, playQueueDuration: duration });
                }
              }
              set({ loginSeqsCompleted: get().loginSeqsCompleted + 1 });
            }
          })
          .catch(function () { set({ isLoginSeqErrors: true }); });

        let historyPromise = MuvikaService.getHistory(sessionToken)
          .then(function (res) {
            if (res.data.error) {
              set({ isLoginSeqErrors: true });
            } else {
              let history = { ...res.data.data };
              if (history) {
                if (history.items) {
                  for (let i = 0; i < history.items.length; i++) {
                    history.items[i].position = i;
                  }
                  performanceStore.setState({ history: history });
                }
              }
              set({ loginSeqsCompleted: get().loginSeqsCompleted + 1 });
            }
          })
          .catch(function () { set({ isLoginSeqErrors: true }); });

        let playListsPromise = MuvikaService.getPlayLists(sessionToken)
          .then(function (res) {
            if (res.data.error) {
              set({ isLoginSeqErrors: true });
            } else {
              let playLists = [...res.data.data.items];
              for (let i = 0; i < playLists.length; i++) {
                let duration = 0;
                for (let j = 0; j < playLists[i].items.length; j++) {
                  playLists[i].items[j].position = j;
                  playLists[i].items[j].incoming = duration;
                  duration += playLists[i].items[j].track.length.split(':').reduce((acc, time) => (60 * acc) + +time);
                }
              }
              performanceStore.setState({ isSet: true, playLists: playLists, totalCount: res.data.data.items.length, isWaiting: false });
              set({ loginSeqsCompleted: get().loginSeqsCompleted + 1 });
            }
          })
          .catch(function () { set({ isLoginSeqErrors: true }); });

        let favoritesPromise = MuvikaService.getFavorites(sessionToken, 500, 1)
          .then(function (res) {
            console.log(res);
            if (res.data.error) {
              set({ isLoginSeqErrors: true });
            } else {
              let tracksSorted = res.data.data.items.sort(function (a, b) { return a.user_rating > b.user_rating; });
              favoritesStore.setState({ isSet: true, tracks: tracksSorted, totalCount: res.data.data.items_total, isWaiting: false });
              if (tracksSorted.length < 500) {
                favoritesStore.setState({ isFinished: true });
              }
              set({ loginSeqsCompleted: get().loginSeqsCompleted + 1 });
            }
          })
          .catch(function () { set({ isLoginSeqErrors: true }); });

        let singersPromise = MuvikaService.getSingers(sessionToken, 25, 1)
          .then(function (res) {
            if (res.data.error) {
              set({ isLoginSeqErrors: true });
            } else {
              let singersList = res.data.data.items;
              singersStore.setState({ isSet: true, singers: singersList, totalCount: res.data.data.items_total, isWaiting: false });
              if (singersList.length < 25) {
                singersStore.setState({ isFinished: true });
              }
              set({ loginSeqsCompleted: get().loginSeqsCompleted + 1 });
            }
          })
          .catch(function () { set({ isLoginSeqErrors: true }); });

        let latestPromise = MuvikaService.getLatest(sessionToken, 25, 1)
          .then(function (res) {
            if (res.data.error) {
              set({ isLoginSeqErrors: true });
            } else {
              newTracksStore.setState({ isSet: true, tracks: res.data.data.items, totalCount: res.data.data.items_total, isWaiting: false });

            }
          })
          .catch(function () { set({ isLoginSeqErrors: true }); });

        Promise.all([settingsPromise, playQueuePromise, historyPromise, playListsPromise, favoritesPromise, singersPromise, latestPromise, newsPromise])
          .then(function () {
            if (get().isLoginSeqErrors) {
              if (isFirst) {
                setTimeout(() => {
                  get().loginSeq(sessionToken, false);
                }, 5000);
              } else {
                set({ isLoggedIn: true, isLoginSeqError: true, isWaiting: false, isWaitingLoggedIn: false, isWaitingBack: false });
              }
            } else {
              set({ isLoggedIn: true, isLoginSeqError: false, isWaiting: false, isWaitingLoggedIn: false, isWaitingBack: false });
            }
          })
          .catch(function (err) {
            console.log(err);
            set({ isLoggedIn: false, isWaiting: false, isWaitingLoggedIn: false, isWaitingBack: false });
          });
      },
      openSessionAndLogin: (username, password) => {
        set({ isSessionOpening: true });
        console.log("opening session");
        MuvikaService.openSession()
          .then(function (res) {
            //console.log(JSON.stringify(res));
            if (res.data.error) {
              set({ isSessionOpen: false, isLoggedIn: false, isThrownOut: false, isSessionOpening: false });
              if (res.data.error.details.length > 0) {
                messageStore.getState().setError("", res.data.error.code, res.data.error.details);
              } else {
                messageStore.getState().setError("", 1000010, TR.cm_session_start_failed);
              }
            } else {
              let sessionToken = res.data.session_token;
              set({ isSessionOpen: true, sessionToken: sessionToken, isThrownOut: false, isSessionOpening: false });
              get().login(username, password);
            }
          })
          .catch(function () { });
      },
      login: (username, password) => {
        set({ isWaiting: true });
        const sessionToken = get().sessionToken;
        MuvikaService.login(sessionToken, username, password)
          .then(function (res) {
            //console.log(res);
            if (res.data.error) {
              set({ isLoggedIn: false, isWaiting: false });
              if (res.data.error.code === sessionExpiredCode) {
                get().openSessionAndLogin(username, password);
              } else {
                messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
              }
            } else {
              set({ session: res.data.data, isLoggedAs: null });
              navigationStore.getState().setUnsubscriptionDialogShown(false);
              navigationStore.getState().setPopUpDialogShown(false);
              let account = res.data.data.account;
              let urls = res.data.data.urls;
              let language = account.language.toLowerCase();
              TR.setLanguage(language);
              localStorage.setItem(muvikaAttrs.service + "-session-language", JSON.stringify(language));
              document.title = TR.ww_page_title;
              environmentStore.getState().getEnvironment(sessionToken);
              //account.subscription.order_info.popup_msg="Pöö";
              accountStore.setState({ isSet: true, account: { ...account }, urls: urls });
              if(songbookQueueStore.getState().currentUser !== account.username){
                songbookQueueStore.getState().reset();
                songbookQueueStore.setState({currentUser: account.username})
              }
              get().loginSeq(sessionToken, true);
              let command = res.data.data.command;
              if (command) {
                let commandCmd = command.cmd;
                switch (commandCmd) {
                  case "show_msg":
                    statusStore.setState({ isMessage: true, messageTitle: command.title, message: command.msg });
                    break;
                  case "sw_update":
                    statusStore.setState({ isUpdateable: true, isForceUpdate: command.sw_release.force_update });
                    break;
                }
              }
            }
          })
          .catch(function (err) {
            messageStore.getState().setError(sessionToken, 0, "FAIL");
            set({ isLoggedIn: false, isWaiting: false });
          });
      },
      /* songbookLogin: (songbookId, isSongbookPublicMode = false, isSongbookPublicBoothMode = false) => {
    
const sessionToken = get().sessionToken;
        MuvikaService.songbookLogin(sessionToken, songbookId)
          .then(function (res) {
            //console.log(res);
            if (res.data.error) {
              set({ isSongbookLoggedIn: false });
              messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
            } else {
              let session = res.data.data;
              let language = session.account.language.toLowerCase();
              TR.setLanguage(language);
              document.title = TR.ww_page_title;
              localStorage.setItem(muvikaAttrs.service+"-session-language", JSON.stringify(language));
              set({ isSongbookLoggedIn: true, session: session, isSongbookWelcomeRead: false, isSongbookPublicMode: isSongbookPublicMode, isSongbookPublicBoothMode: isSongbookPublicBoothMode });
            }
          })
          .catch(function () { });
      }, */
      openSessionAndOneTimeLogin: (username, code, reload = true, navigateToRoot = false) => {
        set({ isSessionOpening: true, isThrownOut: false, isWaitingLoggedIn: true, isWaitingBack:true });
        const sessionToken = get().sessionToken;
        console.log("opening session");
        MuvikaService.openSession()
          .then(function (res) {
            console.log(res);
            if (res.data.error) {
              console.log("isWaitingLoggedIn: false");
              set({ isSessionOpen: false, isLoggedIn: false, isThrownOut: false, isSessionOpening: false, isWaitingLoggedIn: false, isWaitingBack: false });
              if (res.data.error.details.length > 0) {
                messageStore.getState().setError("", res.data.error.code, res.data.error.details);
              } else {
                messageStore.getState().setError("", 1000010, TR.cm_session_start_failed);
              }
            } else {
              let sessionToken = res.data.session_token;
              set({ isSessionOpen: true, sessionToken: sessionToken, isThrownOut: false });
              console.log("isLoggedAs", "pöö");
              get().oneTimeLogin(username, code, reload, navigateToRoot);
            }
          })
          .catch(function () { console.log("isWaitingLoggedIn: false"); set({ isWaitingLoggedIn: false }); });
      },
      openSessionAndOneTimeLoginWithUsername: (username, code, reload = true, navigateToRoot = false) => {
        set({ isSessionOpening: true, isThrownOut: false });
        console.log("opening session");
        MuvikaService.openSession()
          .then(function (res) {
            console.log(res);
            if (res.data.error) {
              set({ isSessionOpen: false, isLoggedIn: false, isThrownOut: false, isSessionOpening: false });
              if (res.data.error.details.length > 0) {
                messageStore.getState().setError("", res.data.error.code, res.data.error.details);
              } else {
                messageStore.getState().setError("", 1000010, TR.cm_session_start_failed);
              }
            } else {
              let sessionToken = res.data.session_token;
              set({ isSessionOpen: true, sessionToken: sessionToken, isThrownOut: false });
              console.log("isLoggedAs", "pöö");
              get().oneTimeLogin(username, code, reload, navigateToRoot, username);
            }
          })
          .catch(function () { });
      },
      oneTimeLogin: (username, code, reload = false, navigateToRoot = false, isLoggedAs = null) => {
        const sessionToken = get().sessionToken;
        MuvikaService.oneTimeLogin(sessionToken, username, code)
          .then(function (res) {
            console.log("oneTimeLogin", res.data);
            if (res.data.error) {
              console.log("isWaitingLoggedIn: false");
              set({ isLoggedIn: false, isSessionOpening: false, isWaitingLoggedIn: false, isWaitingBack: false });
              messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
            } else {
              console.log("isLoggedAs", isLoggedAs);
              get().loginSeq(sessionToken, true);
              let account = res.data.data.account;
              console.log("isLoggedAs", account);
              let urls = res.data.data.urls;
              let language = account.language.toLowerCase();
              TR.setLanguage(language);
              localStorage.setItem(muvikaAttrs.service + "-session-language", JSON.stringify(language));
              document.title = TR.ww_page_title;
              environmentStore.getState().getEnvironment(sessionToken);
              accountStore.setState({ isSet: true, account: { ...account }, urls: urls });
              if(songbookQueueStore.getState().currentUser !== account.username){
                songbookQueueStore.getState().reset();
                songbookQueueStore.setState({currentUser: account.username})
              }
              newsStore.getState().getNews(sessionToken, 25);
              homeStore.getState().getTrendingTracks(sessionToken, 50);
              homeStore.getState().getPublicPlaylists(sessionToken);
              console.log("isLoggedAs", isLoggedAs);
              set({ session: res.data.data, isSessionOpening: false, isLoggedAs: isLoggedAs, isThrownOut: false });
            }
            if (reload) {
              window.location.reload();
            }
            if (navigateToRoot) {
              var href = window.location.href;
              let hrefSplitted = href.split("?");
              if (hrefSplitted.length > 1) {
                href = hrefSplitted[0];
              }
              window.history.pushState('object', document.title, href);
            }
          })
          .catch(function (err) { console.log("err", err); });
      },
      logout: () => {
        const sessionToken = get().sessionToken;
        MuvikaService.logout(sessionToken)
          .then(function (res) {
            if (res.data.error) {
              messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
            } else {
              playerStore.getState().setIsInIosExternalScreen(false);
              playerStore.getState().setIsInAndroidExternalScreen(false);
              playerStore.getState().setIsInExternalWindow(false);
              console.log("isWaitingLoggedIn: false");
              set({ isThrownOut: false, isLoggedIn: false, isSongbookLoggedIn: false, isSongbookPublicMode: false, isSongbookPublicBoothMode: false, isLoggedAs: null, isMoveToExternalScreen: false, isApiWindowPerm: false, isWaitingLoggedIn: false });
            }
          })
          .catch(function () { });
      },
      logoutChange: (username, code, isWithUsername = false) => {
        const sessionToken = get().sessionToken;
        MuvikaService.logout(sessionToken)
          .then(function (res) {
            if (res.data.error) {
              messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
            } else {
              accountStore.getState().reset();
              catalogStore.getState().reset();
              environmentStore.getState().reset();
              favoritesStore.getState().reset();
              messageStore.getState().reset();
              musicPlayerStore.getState().reset();
              musicStore.getState().reset();
              navigationStore.getState().reset();
              newsStore.getState().reset();
              homeStore.getState().reset();
              newTracksStore.getState().reset();
              performanceStore.getState().reset();
              playerStore.getState().reset();
              searchStore.getState().reset();
              settingsStore.getState().reset();
              singersStore.getState().reset();
              songListStore.getState().reset();
              timeoutsStore.getState().reset();
              bgFiltersStore.getState().reset();
              bgStylesStore.getState().reset();
              bgPerformanceStore.getState().reset();
              bgSearchStore.getState().reset();
              bgPlaylistsStore.getState().reset();
              musicPlayerStore.getState().reset();
              
              IntervalService.clearAllIntervals();
              IntervalService.clearSongbookInterval();
              IntervalService.clearNewTracksInterval();
              IntervalService.clearSubInterval();
              IntervalService.clearAllStreamUrlTimeouts();
              console.log("isWaitingLoggedIn: false");
              set({
                isSessionOpening: false,
                isLoggedAs: null,
                isThrownOut: false,
                sessionToken: "",
                isAckSmartQ: false,
                externalWindowHandler: null,
                session: null,
                isLoginSeqErrors: false,
                isLoginSeqError: false,
                isWaiting: false,
                requestCount: 0,
                isMoveToExternalScreen: false,
                isApiWindowPerm: false,
                isWaitingLoggedIn: false,
                isAndroidSubMode: false
              });
              console.log("isLoggedAs");
              if (isWithUsername) {
                get().openSessionAndOneTimeLoginWithUsername(username, code, false, true);
              } else {
                get().openSessionAndOneTimeLogin(username, code, false, true);
              }
            }
          })
          .catch(function (err) { console.log("isLoggedAs", err); });
      }
    }
    ),
    {
      name: muvikaAttrs.service + '-storage',
      storage: createJSONStorage(() => localStorage),
      getStorage: () => localStorage,
    }
  )
);

export default sessionStore;